var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 3.46667L14.1422 1.03381C14.293 0.928234 14.5009 0.964913 14.6064 1.11573C14.6456 1.17176 14.6667 1.23849 14.6667 1.30689V9.3598C14.6667 9.54387 14.5174 9.69313 14.3333 9.69313C14.2649 9.69313 14.1982 9.67207 14.1422 9.63287L10.6667 7.2V10C10.6667 10.3682 10.3682 10.6667 10 10.6667H0.666667C0.29848 10.6667 0 10.3682 0 10V0.666667C0 0.29848 0.29848 0 0.666667 0H10C10.3682 0 10.6667 0.29848 10.6667 0.666667V3.46667ZM10.6667 5.57247L13.3333 7.43913V3.22754L10.6667 5.0942V5.57247ZM1.33333 1.33333V9.33333H9.33333V1.33333H1.33333ZM2.66667 2.66667H4V4H2.66667V2.66667Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.68abf70bddc7c10857f962f4af598f54.svg";
export { ForwardRef as ReactComponent };